export const chunk = (arr: Array<string>, size: number) => {
  const output = [];
  for (let i = 0; i < arr.length; i += size) {
    output.push(arr.slice(i, i + size));
  }
  return output;
};

export const getProjectIdFromUrl = (
  url: string = window.location.pathname,
): null | string => {
  const projectsPart = url.match(/projects\/([^/?]*)/);
  return projectsPart && projectsPart[1];
};

export const queryObjToSearchString = (queryParamsObj = {}): string => {
  const queryString = new URLSearchParams(queryParamsObj).toString();
  return queryString && `?${queryString}`;
};

export const capitalizeFirst = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1);
